import * as React from "react";
import { connect, type ConnectedProps } from "react-redux";
import { type ThunkDispatch } from "redux-thunk";
import { hideDialog } from "../../../Actions/Dialogs/DialogActions";
import { addOrderReference } from "../../../Actions/SellScreen/SellScreenActions";
import Button from "../../../Common/Buttons/Button";
import PopupManager from "../../../Common/Popups/PopupManager";
import { determineDataSource } from "../../../Data/DataStores/DataSource";
import { type RootState } from "../../../Reducers/ShopfrontReducers";
import { type LocalCustomer } from "../../Customers/CustomerTypes";

function mapStateToProps(state: RootState): {
    customer: null | string;
} {
    return {
        customer: state.sellscreen.sale.customer === false ? null : state.sellscreen.sale.customer.uuid,
    };
}

const connector = connect(mapStateToProps);

interface Props extends ConnectedProps<typeof connector> {
    dispatch: ThunkDispatch<any, any, any>;
    reference: string;
    customer: null | string;
}

interface State {
    reference: string;
    customer: null | LocalCustomer;
    required: boolean;
}

export class AddOrderReference extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            reference: this.props.reference,
            customer : null,
            required : false,
        };
    }

    public componentDidMount(): void {
        this.loadCustomer();
    }

    protected async loadCustomer(): Promise<void> {
        if(!this.props.customer) {
            return;
        }

        try {
            const source = await determineDataSource();
            const customer = await source.customers.get(this.props.customer);

            if(customer && customer.require_order_reference) {
                this.setState({
                    required: true,
                });
            }
        } catch {
            // Do nothing
        }
    }

    protected handleReferenceChange = (e: React.FormEvent<HTMLInputElement>): void => {
        this.setState({
            reference: e.currentTarget.value,
        });
    };

    protected handleCancel = (): void => {
        if(this.state.required && !this.state.reference.trim()) {
            PopupManager.error("A order reference is required for this customer");

            return;
        }

        this.props.dispatch(hideDialog());
    };

    protected handleSave = (): void => {
        if(this.state.required && !this.state.reference.trim()) {
            PopupManager.error("A order reference is required for this customer");

            return;
        }

        this.props.dispatch(addOrderReference(this.state.reference));
        this.handleCancel();
    };

    protected handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>): void => {
        if(e.key === "Enter") {
            this.handleSave();
            e.stopPropagation();
        }
    };

    public render(): React.ReactNode {
        return (
            <div className="add-order-reference">
                <input
                    value={this.state.reference}
                    onChange={this.handleReferenceChange}
                    onKeyDown={this.handleKeyDown}
                    autoFocus
                />
                <div className="buttons">
                    <Button classes={[ "button-cancel" ]} onClick={this.handleCancel}>Cancel</Button>
                    <Button classes={[ "button-save" ]} onClick={this.handleSave}>Save</Button>
                </div>
            </div>
        );
    }
}

export default connector(AddOrderReference);
